// complementary-color-sync.js
(function () {
    const cache = new Map(); // handle -> product JSON

    async function fetchProductData(handle) {
        if (cache.has(handle)) return cache.get(handle);
        const res = await fetch(`/products/${handle}.js`);
        const data = await res.json();
        cache.set(handle, data);
        return data;
    }

    function getColorOptionPosition(product) {
        return product.options.findIndex(opt => {
            const name = typeof opt === 'string' ? opt : opt.name;
            return ['farbe', 'color', 'colour'].includes(name.toLowerCase());
        });
    }
    
    async function updateComplementarySlides(selectedColor) {
        const slides = document.querySelectorAll('[data-complementary-product]');

        for (const slide of slides) {
            const handle = slide.dataset.handle;
            const baseUrl = slide.dataset.baseUrl;
            if (!handle) continue;

            try {
                const product = await fetchProductData(handle);
                const colorPos = getColorOptionPosition(product);
                if (colorPos === -1) continue;

                const matchedVariant = product.variants.find(
                    v => v.options[colorPos] === selectedColor
                );
                if (!matchedVariant) continue; // Farbe gibt's bei diesem Produkt nicht -> Fallback bleibt stehen

                const img = slide.querySelector('.hdt-complementary-img');
                const variantImage =
                    matchedVariant.featured_image?.src || product.featured_image;
                if (img && variantImage) {
                    img.src = variantImage.replace(/(\.[a-z]+)(\?|$)/i, '_800x$1$2');
                    if (img.srcset) img.removeAttribute('srcset');
                }

                const newUrl = `${baseUrl}?variant=${matchedVariant.id}`;
                slide.querySelectorAll('[data-complementary-link]').forEach(link => {
                    link.href = newUrl;
                });

                const hiddenInput = slide.querySelector('[data-complementary-variant-id]');
                if (hiddenInput) hiddenInput.value = matchedVariant.id;

            } catch (err) {
                console.error('Complementary sync failed for', handle, err);
            }
        }
    }

    // Lauscht auf jedes Variant-Picker-Change, egal ob via Swatch-Klick
    // oder via Bilder-Slider (slider_main_select_fn dispatcht selbst ein change-Event)
    document.addEventListener('change', (event) => {
        const input = event.target;
        if (input.tagName !== 'INPUT' || input.type !== 'radio' || !input.hasAttribute('is-value')) return;

        const fieldset = input.closest('fieldset[data-option-name]');
        if (!fieldset) return;

        const optionName = fieldset.dataset.optionName.toLowerCase();
        if (!['farbe', 'color', 'colour'].includes(optionName)) return;

        const selectedColor = input.value;
        if (selectedColor) updateComplementarySlides(selectedColor);
    });
})();